import { render } from "./OfferExtraContainer.vue?vue&type=template&id=385e18dd"
import script from "./OfferExtraContainer.vue?vue&type=script&lang=js"
export * from "./OfferExtraContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__